<template>
  <div class="accountState">
    <div class="center">
      <el-tabs v-model="activeName">
        <el-tab-pane name="information">
          <template slot="label">
            <!-- 插槽 -->
            <slot name="label"></slot>
          </template>
          <div class="information">
            <el-form :model="informationData" label-width="130px" label-position="right"
                     :rules="rules" ref="ruleForm" class="demo-ruleForm">
              <el-form-item label="供应商：" prop="supplier">
                <el-input size="mini" placeholder="请输入供应商"
                          v-model="informationData.supplier"></el-input>
              </el-form-item>
              <div style="position: absolute;left: 350px;top: 11px;">
                <i v-if="informationData.supplier!=oldSupplier" class="el-icon-warning icon"
                   :title="oldSupplier"></i>
              </div>

              <el-row v-if="settlement === 1">
                <el-col :span="14">
                  <el-form-item label="合计含税费用：">
                    {{ informationData.sumIncluded }}
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="合计不含税费用：" label-width="130px">
                    <div style="display: flex;flex-direction: row;align-items: center;">
                      <div>{{ informationData.sumNotIncluded }}</div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="settlement !==1">
                <el-col :span="14">
                  <el-form-item label="含税预结算费用：" label-width="130px">
                    {{ informationData.sumBudget }}
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="不含税预结算费用：" label-width="150px">
                    {{ informationData.sumNotBudget }}
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="标题：" prop="title" label-width="130px">
                <el-input size="mini" placeholder="请输入对账单标题"
                          v-model="informationData.title"></el-input>
              </el-form-item>
              <el-form-item label="是否抵扣开票：" label-width="130px" prop="isInvoicing">
                <el-radio-group v-model="informationData.isInvoicing" @change="isInvoicingChange">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-row :gutter="24" v-if="informationData.isInvoicing ===1">
                <el-col :span="13">
                  <el-form-item label="选择抵扣费用：" style="margin-bottom: 17px;width:100%"
                                class="costList" prop="instruction">
                    <el-select size="mini" filterable v-model="informationData.instruction"
                               placeholder="请选择抵扣费用数据" style=" width: 100%;"
                               @change="(value)=>{
                                   this.informationData.Deductible = value.remainingDiscountAmount
                                 }">
                      <el-option v-for="item in InvoicingList" :key="item.id" :value="item"
                                 :label="item.deductionNum"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="抵扣费用：" label-width="110px" style="margin-bottom: 17px;"
                                prop="Deductible">
                    <el-input size="mini" v-model="informationData.Deductible"
                              style="width: 180px;" :disabled="informationData.instruction?false:true" :placeholder="informationData.instruction?'请输入抵扣费用':'请先选择抵扣费用数据'" >
                      <i slot="suffix" class="input-right">元</i>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span='10'>
                  <el-form-item label='最多抵扣费用:' label-width='100px' style='margin-bottom: 17px;'
                                prop='remainingDiscountAmount'>
                    <span>{{ informationData.remainingDiscountAmount }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="备注：" label-width="130px">
                <el-input size="mini" placeholder="请输入备注" :autosize="{ minRows: 5, maxRows: 10}"
                          v-model="informationData.remark"
                          style="width:90% "
                          type="textarea"></el-input>
              </el-form-item>
              <el-form-item label-width="0px" style="text-align: center;">
                <el-button type="primary" size="mini" @click="confirmButton">确认</el-button>
                <el-button type="info" size="mini" @click="dialogClose">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane name="cost">
          <template slot="label">
            <slot name="label2"></slot>
          </template>
          <div class="cost">
            <div class="operation">
              <div class="total" style="margin-left: 35px">
                <el-row style="margin-bottom: 10px">
                  <el-col :span="9" style="font-size: 14px;color: #606266;font-weight: 700;"
                          v-if="settlement ===1">
                    合计含税费用:{{ informationData.sumIncluded }}
                  </el-col>
                  <el-col :span="9" style="font-size: 14px;color: #606266;font-weight: 700;" v-else>
                    合计含税预结算费用:{{ informationData.sumBudget }}
                  </el-col>
                  <el-col :span="9" style="font-size: 14px;color: #606266;font-weight: 700;"
                          v-if="settlement ===1">
                    合计不含税费用:{{ informationData.sumNotIncluded }}
                  </el-col>

                  <el-col :span="9" style="font-size: 14px;color: #606266;font-weight: 700;" v-else>
                    合计不含税预结算费用:{{ informationData.sumNotBudget }}
                  </el-col>
                </el-row>
              </div>
              <div class="operationTitle" v-if="importShow">
                <div class="line"/>
                <span>已选择运单</span>
              </div>
              <div class="operationTable">
                <el-table
                  v-loading="checkLoad"
                  :data="tableData"
                  style="width: 100%"
                  border
                  :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
                >
                  <el-table-column prop="supplierName" label="供应商" align="center" width="200"
                                   show-overflow-tooltip/>
                  <el-table-column prop="batchNumber" label="批次号" align="center"
                                   show-overflow-tooltip/>
                  <el-table-column prop="waybillNo" label="运单编号" align="center"
                                   show-overflow-tooltip/>
                  <el-table-column prop="frameNumber" label="车架号" align="center" width="150"
                                   show-overflow-tooltip/>
                  <el-table-column prop="brandName" label="品牌" align="center"
                                   show-overflow-tooltip/>
                  <el-table-column prop="modelName" label="型号" align="center"
                                   show-overflow-tooltip/>
                  <el-table-column prop="plannedDate" label="计划日期" align="center"
                                   show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.plannedDate |formatTime }}</template>
                  </el-table-column>
                  <el-table-column prop="shippingDate" label="发运日期" align="center"
                                   show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.shippingDate |formatTime }}</template>
                  </el-table-column>
                  <el-table-column prop="deliveryDate" label="交车日期" align="center"
                                   show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.deliveryDate |formatTime }}</template>
                  </el-table-column>
                  <el-table-column label="起运地" align="center" width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{
                        scope.row.startType == 0 ?
                          scope.row.startName : scope.row.startPortName
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column label="交车地" align="center">
                    <template slot-scope="scope">
                      {{
                        scope.row.deliveryType == 0 ?
                          scope.row.deliveryName : scope.row.deliveryPortName
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="taxRate" label="税率(%)" align="center"/>
                  <el-table-column v-if="settlement === 1" prop="taxContractPrice" label="含税合同价"
                                   align="center"/>
                  <el-table-column v-else prop="taxPreparePrice" label="含税预结算价" align="center"/>
                  <el-table-column v-if="settlement === 1" prop="contractPrice" label="不含税合同价"
                                   align="center"/>
                  <el-table-column v-else prop="preparePrice" label="不含税预结算价" align="center"/>
                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <div class="iconError">
                        <!-- 1 为运单费用-->
                        <i class="el-icon-error" @click="deleteClick(scope.$index,1)"></i>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>

              </div>
              <div class="operationTitle" v-if="importShow">
                <div class="line"/>
                <span>未选择运单</span>
              </div>
              <div class="operationTable" v-if="importShow">
                <el-table
                  v-loading="checkLoad"
                  :data="notTableData"
                  style="width: 80%"
                  border
                  :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
                >
                  <el-table-column label="序号" align="center" width="50px">
                    <div slot-scope="scope">{{ scope.$index + 1 }}</div>
                  </el-table-column>
                  <el-table-column prop="supplierName" label="供应商" align="center"/>
                  <el-table-column prop="waybillNo" label="运单编号" align="center"/>
                  <el-table-column prop="batchNumber" label="批次号" align="center"/>
                  <el-table-column prop="chassisNumber" label="底盘号" align="center"/>
                  <el-table-column prop="brandName" label="品牌" align="center"/>
                  <el-table-column prop="modelName" label="型号" align="center"/>
                  <el-table-column prop="expenseType" label="费用类型" align="center"/>
                  <el-table-column prop="taxRate" label="税率(%)" align="center"/>
                  <el-table-column prop="included" label="含税费用" align="center"/>
                  <el-table-column prop="afterTax" label="税后费用" align="center"/>
                  <el-table-column prop="remark" label="说明" align="center"/>
                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button size="mini" type="primary" @click="addWaybill(scope.$index)">添加
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

          </div>
        </el-tab-pane>
        <!-- 其他费用 -->
        <el-tab-pane name="otherCost">
          <template slot="label">
            <slot name="label3"></slot>
          </template>
          <slot name="otherCost"></slot>
          <div class="otherCost">
            <div class="total" style="margin-left: 35px">
              <el-row style="margin-bottom: 10px">
                <el-col :span="7" style="font-size: 14px;color: #606266;font-weight: 700;">
                  合计含税费用:{{ otherIncluded }}
                </el-col>
                <el-col :span="7" style="font-size: 14px;color: #606266;font-weight: 700;">
                  合计不含税费用:{{ otherNotIncluded }}
                </el-col>
              </el-row>
              <div class="otherAdd" style="margin-bottom: 10px" @click="otherAddClick">添加</div>
            </div>
            <el-table
              v-loading="checkLoad"
              :data="otherTableData"
              style="width: 100%"
              border
              :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
            >
              <el-table-column label="序号" align="center" width="50px">
                <div slot-scope="scope">{{ scope.$index + 1 }}</div>
              </el-table-column>
              <el-table-column prop="costNum" label="费用编号" align="center"/>
              <el-table-column prop="costTypeName" label="费用类型" align="center"/>
              <el-table-column prop="costInstruction" label="费用说明" align="center"/>
              <el-table-column prop="costTime" label="费用时间" align="center">
                <template slot-scope="scope">{{ scope.row.costTime|formatTime }}</template>
              </el-table-column>
              <el-table-column prop="taxRate" label="税率(%)" align="center"/>
              <el-table-column prop="costAmount" label="含税价" align="center"/>
              <el-table-column prop="excludingTaxAmount" label="不含税价" align="center"/>

              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <div class="iconError">
                    <!--   2 为其他费用删除-->
                    <i class="el-icon-error" @click="deleteClick(scope.$index,2)"></i>
                  </div>
                </template>
              </el-table-column>
            </el-table>

          </div>
        </el-tab-pane>
        <slot name="elTabPane"></slot>
      </el-tabs>

    </div>
    <el-dialog title="添加其他费用" :visible.sync="otherAddFlag" append-to-body width="750px">
      <otherAdd @otherDataCelect="otherData" ref="otherAdds"
                :otherDateProps="JSON.parse(JSON.stringify(otherTableData))"
                :consignor-id="consignorId"></otherAdd>
    </el-dialog>

  </div>
</template>

<script>
import { formatTime } from '@/config/mUtils';
import {
  customerAdd,
  deductionInvoicingCostGetAllByCompanyId,
} from '@/service/getData';
import otherAdd from './otherAdd.vue';

export default {
  name: 'accountState',
  components: {
    otherAdd,
  },
  props: {
    importShow: {
      default: false,
    },
    dialogCloseParent: {
      type: Function,
      require: true,
      default: null,
    },
    settlement: {
      default: 1,
    },
  },
  data() {
    return {
      activeName: 'information',
      otherAddFlag: false,
      isDisabled: false, // 是否启用合同价
      tableData: [],
      informationData: {
        supplier: '', // 供应商
        Settlement: 1, // 结算方式
        sumIncluded: '', // 合计含税费用
        sumNotIncluded: '', // 合计不含税费用
        sumBudget: '', // 合计含税预结算费用
        sumNotBudget: '', // 合计不含税预结算费用
        title: '', //
        isInvoicing: 0, // 是否抵扣开票
        instruction: '', // 选择抵扣费用
        Deductible: '', // 抵扣费用
        remainingDiscountAmount: 0,// 最高抵扣费用
        remark: '',
      },
      InvoicingList: [], // 选择抵扣费用 下拉
      consignorId: '', // 公司id
      checkLoad: false,
      notTableData: [],
      otherTableData: [],
      otherIncluded: 0,
      otherNotIncluded: 0,
      sumContract: 0,
      sumNotIncluded: 0,
      sumBudget: 0,
      sumNotBudget: 0,
      oldSupplier: '', // 原供应商
      rules: {
        plan: {
          required: true,
          message: ' ',
          trigger: 'blur',
        },
        Settlement: {
          required: true,
          message: '请选择结算方式',
          trigger: 'blur',
        },

        title: {
          required: true,
          message: '请输入对账单标题',
          trigger: 'blur',
        },
        supplier: {
          required: true,
          message: '请输入供应商',
          trigger: 'blur',
        },
        isInvoicing: {
          required: true,
          message: '请选择是否抵扣开票',
          trigger: 'blur',
        },
        instruction: {
          required: true,
          message: '请选择抵扣费用数据',
          trigger: 'blur',
        },
        Deductible: {
          required: true,
          message: '请输入抵扣费用',
          trigger: 'blur',
        },

      },
    };
  },

  watch: {
    // 监听已选择运单
    tableData(val) {
      // 运单费用含税费用
      this.sumContract = this.calculation(val, 'taxContractPrice');
      // 运单费用不含税费用
      this.sumNotIncluded = this.calculation(val, 'contractPrice');
      // 运单费用含税预结算费用
      this.sumBudget = this.calculation(val, 'taxPreparePrice');
      // 运单费用不含税预结算费用
      this.sumNotBudget = this.calculation(val, 'preparePrice');


      // 合计含税费用
      this.informationData.sumIncluded = Number(this.sumContract + this.otherIncluded)
        .toFixed(2);
      // 合计不含税费用
      this.informationData.sumNotIncluded = Number(this.sumNotIncluded + this.otherNotIncluded)
        .toFixed(2);
      // 合计含税预结算费用
      this.informationData.sumBudget = Number(this.sumBudget + this.otherNotIncluded)
        .toFixed(2);
      // 合计不含税预结算费用
      this.informationData.sumNotBudget = Number(this.sumNotBudget + this.otherNotIncluded)
        .toFixed(2);
      // 判断 不/含税合同价是否为空  是就禁用
      this.decideContract(val, this.otherTableData);
      // 保存原始供应商
      this.informationData.supplier = this.oldSupplier = val[0].supplierName;
    },
    otherTableData(val) {
      // 其他费用
      this.otherIncluded = this.calculation(val, 'costAmount');
      this.otherNotIncluded = this.calculation(val, 'excludingTaxAmount');
      // 合计含税费用
      this.informationData.sumIncluded = Number(this.sumContract + this.otherIncluded)
        .toFixed(2);
      // 合计不含税费用
      this.informationData.sumNotIncluded = Number(this.sumNotIncluded + this.otherNotIncluded)
        .toFixed(2);
      // 合计含税预结算费用
      this.informationData.sumBudget = Number(this.sumBudget + this.otherNotIncluded)
        .toFixed(2);
      // 合计不含税预结算费用
      this.informationData.sumNotBudget = Number(this.sumNotBudget + this.otherNotIncluded)
        .toFixed(2);
      // 判断 不/含税合同价是否为空  是就禁用
      this.decideContract(this.tableData, val);
    },
  },
  filters: {
    prepareTypeFormat(value) {
      let returnStr = '';
      switch (value) {
        case 1:
          returnStr = '固定';
          break;
        case 2:
          returnStr = '比例';
          break;
        default:
          returnStr = '';
          break;
      }
      return returnStr;
    },
    isReconciliationFormat(value) {
      let returnStr = '';
      switch (value) {
        case 1:
          returnStr = '否';
          break;
        case 2:
          returnStr = '是';
          break;
        default:
          returnStr = '';
          break;
      }
      return returnStr;
    },
    formatTime(val) {
      if (val) {
        return formatTime(val, 'yyyy-mm-dd ');
      }
      return '';
    },
  },
  methods: {
    init(data) {
      this.tableData = JSON.parse(JSON.stringify(data));
      this.informationData.sumIncluded = this.calculation(this.tableData, 'taxContractPrice');
      this.informationData.sumNotIncluded = this.calculation(this.tableData, 'contractPrice');
      this.informationData.sumBudget = this.calculation(this.tableData, 'taxPreparePrice');
      this.informationData.sumNotBudget = this.calculation(this.tableData, 'preparePrice');
      // 保存供应商id
      this.consignorId = this.tableData.length > 0 ? this.tableData[0].supplierId : '';
      this.decideContract(this.tableData, this.otherTableData);
      // 保存原始供应商
      this.informationData.supplier = this.oldSupplier = this.tableData.length > 0 ? this.tableData[0].supplierName : '';
    },
    // 生成对账单
    async _customerAdd() {
      const {
        supplier,
        sumIncluded,
        sumNotIncluded,
        title,
        isInvoicing,
        instruction,
        Deductible,
        remark,
        Settlement,
        sumBudget,
        sumNotBudget,
      } = this.informationData;
      let settIds = '';
      this.tableData.forEach((item, index) => {
        // 最后一个不加逗号
        settIds += index === this.tableData.length - 1 ? item.id : `${item.id},`;
      });
      let otherCostIds = '';
      this.otherTableData.forEach((item, index) => {
        // 最后一个不加逗号
        otherCostIds += index === this.otherTableData.length - 1 ? item.id : `${item.id},`;
      });
      const obj = {
        companyId: this.consignorId,
        companyNameOld: this.oldSupplier,
        companyNameNew: supplier,
        settType: this.settlement,
        taxPrice: Number(sumIncluded),
        noTaxPrice: Number(sumNotIncluded),
        taxSettPrice: sumBudget,
        noTaxSettPrice: sumNotBudget,
        title,
        isDeduct: isInvoicing,
        deductId: instruction.id,
        deductAmount: Deductible,
        remark,
        type: 6, // 委托商港口结算
        settIds: this.tableData.length > 0 ? settIds : '',
        otherCostIds: this.otherTableData.length > 0 ? otherCostIds : '',
      };
      // if (isInvoicing === 1) {
      //   delete obj.deductAmount;
      // }
      const res = await customerAdd(obj);
      if (res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.$parent.$parent.searchBtn();
      this.dialogClose();
    },
    async _deductionInvoicingCostGetAllByCompanyId(id) {
      const res = await deductionInvoicingCostGetAllByCompanyId(id);
      if (res.status !== 0) return this.$message.error(res.message);
      this.informationData.remainingDiscountAmount = res.data[0].remainingDiscountAmount;
      this.InvoicingList = res.data.map(item => ({
        id: item.id,
        deductionNum: item.instruction,
        remainingDiscountAmount: item.remainingDiscountAmount,
      }));
    },
    dialogClose() {
      this.activeName = 'information';
      // this.dialogCloseParent();
      this.$parent.$parent.dialogClose();
      // this.$parent.$parent.searchBtn();
      // 清空
      for (const informationDataKey in this.informationData) {
        this.informationData[informationDataKey] = '';
      }
      // 清除提示
      this.$refs.ruleForm.resetFields();
    },
    // 清除数据 父组件调用
    clearData() {
      for (const informationDataKey in this.informationData) {
        this.informationData[informationDataKey] = '';
      }
      // 清除提示
      this.$refs.ruleForm.resetFields();
    },
    calculation(table, zi) {
      let sum = 0;
      table.forEach((item) => {
        sum += Number(item[zi]);
      });
      return sum.toFixed(2);
    },
    // flag 1 运单费用 2 其他费用 删除
    deleteClick(index, flag) {
      if (flag === 1) {
        const array = this.tableData.splice(index, 1);

        array.forEach((item) => {
          this.notTableData.push(item);
        });
        // 已选选择运单费用  触发父组件  将数据传给父组件重新回显勾选
        this.$emit('selectionTable', this.tableData);
      } else {
        this.otherTableData.splice(index, 1);
        // 触发子组件 其他费用添加  联动多选表格，重新勾选
        this.$refs.otherAdds.toggleSelection();
      }
    },
    otherAddClick() {
      if (this.tableData.length <= 0) return this.$message.warning('供应商id为空，请勾选数据');
      this.consignorId = this.tableData.length > 0 ? this.tableData[0].supplierId : '';
      this.otherAddFlag = true;
      this.$nextTick(() => {
        this.$refs.otherAdds._othercostGetAllByCompanyId();
      });
    },
    // 子组件添加其他费用触发  得到子组件勾选的数据
    otherData(value) {
      this.otherTableData = value;
    },
    // 未选择运单费用 操作添加 添加到已选择运单费用
    addWaybill(index) {
      const a = this.notTableData.splice(index, 1);
      this.tableData.push(a[0]);
      // 已选选择运单费用  触发父组件  将数据传给父组件重新回显勾选
      this.$emit('selectionTable', this.tableData);
    },
    //  判断 不/含税合同价是否为空  value运单费用  value2其他费用
    decideContract(value, value2) {
      let flag = true;
      // 判断 作业费用
      for (const valueElement of value) {
        if (valueElement.taxContractPrice === null || valueElement.contractPrice === null) {
          // 是否禁用选项
          this.isDisabled = true;
          flag = false;
          this.informationData.Settlement = 2;
          break;
        } else {
          flag = true;
        }
      }

      for (const value2Element of value2) {
        if (value2Element.costAmount === null || value2Element.excludingTaxAmount === null) {
          // 是否禁用选项
          this.isDisabled = true;
          flag = false;
          this.informationData.Settlement = 2;
          // 终止foreach 并且不执行后面的代码
          break;
        } else {
          flag = true;
        }
      }

      if (flag) {
        this.isDisabled = false;
      }
    },
    confirmButton() {
      if (this.tableData.length <= 0) return this.$message.warning('作业费用不能为空');
      // if (this.otherTableData.length<=0) return this.$message.warning('其他费用不能为空')
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          await this._customerAdd();
        } else {

        }
      });
    },
    // 是否抵扣开票
    isInvoicingChange(value) {
      const id = this.tableData.length > 0 ? this.tableData[0].supplierId : '';
      if (value === 1) {
        this._deductionInvoicingCostGetAllByCompanyId(id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.accountState {
  padding: 20px;

  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }

  .line + span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }

  ::v-deep.center {
    .el-tabs__nav {
      left: 20px;
    }

    .el-tabs__item.is-active {
      color: #335483
    }

    .el-tabs__item {
      font-weight: bold !important;
    }

    .el-table td, .el-table th {
      padding: 0;
    }

    .cell {
      font-size: 10px;
      padding: 10px 0;
    }

    .information {
      /*width: 83%;*/
      .el-form-item__label {
        font-weight: 700;
      }

      .el-input {
        width: 90%;
      }

      .el-form-item {
        margin-bottom: 9px;
      }

      .costList {
        .el-input {
          width: 100%;
        }
      }

      .icon {
        color: red;
        font-size: 20px;
        margin-left: 20px;

        span {
          font-size: 15px;
        }
      }

    }

    .cost {
      .iconError {
        font-size: 20px;

        i:hover {
          color: #00e1ff;
        }
      }

      .operation {
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;

          .el-button--mini {
            padding: 4px 4px;
          }
        }
      }
    }

    .otherCost {
      .total {
        .otherAdd {
          color: rgba(51, 136, 255, 1);
          text-align: right;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }

  }


}

::v-deep {

  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
    text-align: center;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .el-dialog__headerbtn {
    top: 9px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }

  .el-dialog__body {
    padding: 0;
    overflow: auto;
    max-height: 75vh;
    color: #606266;
  }


}

.accountState .center .cost .operation {
  margin-top: 0px !important;
  padding: 0px;
}

.accountState .center .cost .operationTable {
  padding-right: 0px !important;
}
</style>
